import {
  buildAnalyticsRequest,
  buildAnalyticsSalesPerItemRequest
} from 'helpers/services/api/analyticsHelpers';
import {GET, POST} from 'helpers/services/constants/API_CONSTANTS';
import {
  API_GET_TOTAL_CUSTOMERS,
  API_GET_SALES_PER_HOUR,
  API_GET_TOTAL_SALES,
  API_GET_SALES_PER_ITEM,
  API_ANALYTICS_V3,
  API_ANALYTICS_V3_SALES_PER_ITEM,
  API_ANALYTICS_V3_CHANNELS
} from 'helpers/services/constants/API_ENDPOINTS';
import {request} from 'helpers/services/utils/request';

/** @deprecated Main page legacy analytics – use analytics v2 on /analytics */
export const getCustomersCountApi = async (startDate, endDate) => {
  return request(GET, API_GET_TOTAL_CUSTOMERS(startDate, endDate));
};

/** @deprecated Main page legacy analytics – use analytics v2 on /analytics */
export const getSalesCountApi = async (startDate, endDate) => {
  return request(GET, API_GET_TOTAL_SALES(startDate, endDate));
};

/** @deprecated Main page legacy analytics – use analytics v2 on /analytics */
export const getSalesPerHourApi = async (timezone, startDate, endDate) => {
  return request(GET, API_GET_SALES_PER_HOUR(timezone, startDate, endDate));
};

/** @deprecated Main page legacy analytics – use analytics v2 on /analytics */
export const getSalesPerItemApi = async (startDate, endDate) => {
  return request(GET, API_GET_SALES_PER_ITEM(startDate, endDate));
};

const analyticsConfig = {
  headers: {
    'Content-Type': 'application/json'
  }
};

export const getAnalyticsV3Api = async (locationId, params) => {
  return request(
    POST,
    API_ANALYTICS_V3(locationId),
    {data: buildAnalyticsRequest(params)},
    analyticsConfig
  );
};

export const getAnalyticsV3SalesPerItemApi = async (locationId, params) => {
  return request(
    POST,
    API_ANALYTICS_V3_SALES_PER_ITEM(locationId),
    {data: buildAnalyticsSalesPerItemRequest(params)},
    analyticsConfig
  );
};

export const getAnalyticsV3ChannelsApi = async (locationId) => {
  return request(GET, API_ANALYTICS_V3_CHANNELS(locationId), undefined, {
    silent: true
  });
};
